import axios from "../../axios";
import { getApiErrorInfo } from "../../utilis/api-error";

/**
 * Submit contact form data to backend
 * @param {Object} formData - Contact form data
 * @param {string} formData.name - Contact person name
 * @param {string} formData.email - Contact person email
 * @param {string} formData.organizationName - Organization name
 * @param {string} formData.organizationType - Type of organization
 * @param {string} formData.trackingDescription - Description of tracking needs
 * @returns {Promise<Object>} Response from the backend
 */
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post('/api/contact/submit', {
      name: formData.name,
      email: formData.email,
      organizationName: formData.organizationName,
      organizationType: formData.organizationType,
      trackingDescription: formData.trackingDescription,
      source: 'platform-builder', // To identify where the form was submitted from
      submittedAt: new Date().toISOString()
    });

    return {
      success: true,
      data: response.data,
      message: 'Contact form submitted successfully'
    };
  } catch (error) {
    console.error('Contact form API error:', error);
    
    // Handle different error scenarios
    if (error.response) {
      const { message } = getApiErrorInfo(error);
      return {
        success: false,
        error: error.response.data,
        message: message || 'Server error occurred',
        status: error.response.status
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        success: false,
        error: 'No response from server',
        message: 'Unable to connect to server. Please check your internet connection.',
      };
    } else {
      // Something else happened
      return {
        success: false,
        error: error.message,
        message: 'An unexpected error occurred. Please try again.',
      };
    }
  }
}; 